"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parser = void 0;
const parser = (fileName, options) => {
    const response = {};
    const qsString = fileName.split((options === null || options === void 0 ? void 0 : options.separator) || '~');
    if (qsString.length >= 3) {
        new URLSearchParams(qsString[1]).forEach((value, key) => {
            response[key] = value.includes(',') ? value.split(',') : value;
        });
    }
    return response;
};
exports.parser = parser;
//# sourceMappingURL=parser.js.map